export default __webpack_public_path__ + "static/media/tudo_cni.cf7bb85f.svg";